
import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaWhatsapp, FaAccessibleIcon, FaUtensils, FaUserFriends, FaMusic, FaTree, FaSwimmer } from 'react-icons/fa';
import Gallery from '../components/Gallery';
import SEO from '../components/SEO';
import { sedePorSlug } from '../data/organizacion';
import { breadcrumb, paginaDeSede } from '../data/schema';
import glew_frente_nuevo from '../assets/img/glew/glew_frente_small.png'
import Glew_G1 from '../assets/img/glew/Glew_G1.png'
import Glew_G2 from '../assets/img/glew/Glew_G2.png'
import Glew_G3 from '../assets/img/glew/Glew_G3.png'
import Glew_G4 from '../assets/img/glew/Glew_G4.png'

const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/7KnDCOiB6qIcEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};


const Glew = () => {
  const sede = sedePorSlug('glew');

  // Imágenes para la galería (en producción se reemplazarían por imágenes reales)
  const galleryImages = [
    { src: Glew_G1, alt: 'Centro  Educativo Terapéutico Glew - Actividades especiales' },
    { src: Glew_G2, alt: 'Centro de Día Glew - Atencíon Obras Sociales' },
    { src: Glew_G3, alt: 'CET Glew - Terapias Individuales' },
    { src: Glew_G4, alt: 'CD Glew - Terapia ocupacional, Fonoaudiología, Psicología, Terapia ocupacional, Kinesiología, Fonoaudiología, Psicología' }
  ];

  return (
    <div className="container">
      <SEO
        title="Sede Glew (Guernica) — Mi Lugar CET y Centro de Día"
        description={`Sede Glew de Mi Lugar, en ${sede.direccionCompleta}. CET y Centro de Día con amplios espacios verdes para personas con discapacidad de ${sede.zonas.join(', ')}.`}
        path="/glew"
        image="/images/glew.png"
        jsonLd={[
          breadcrumb([{ nombre: 'Sede Glew', path: '/glew' }]),
          paginaDeSede(sede),
        ]}
      />
      <div className="sede-header">
        <h1>Sede Glew</h1>
        <p>
          Nuestra sede de Glew ofrece un espacio amplio y naturaleza circundante para el desarrollo
          de nuestras actividades terapéuticas. La conocemos como <strong>sede Glew</strong>, aunque
          su dirección postal corresponde a <strong>Guernica</strong>: es el mismo lugar.
          Atendemos familias de {sede.zonas.join(', ')}.
        </p>
      </div>

      <section className="sede-info">
        <div className="sede-details">
          <h2>Sobre nuestra sede</h2>
          <p>La sede de Glew se inauguró como una expansión de Mi Lugar para brindar nuestros servicios a más familias de la zona sur. Ubicada en un entorno más rural, esta sede cuenta con amplios espacios verdes que permiten realizar actividades al aire libre y terapias en contacto con la naturaleza.</p>
          <p>Nuestras instalaciones en Glew están completamente adaptadas y equipadas con todos los recursos necesarios para brindar atención de calidad, en un ambiente tranquilo y estimulante.</p>

          <div className="sede-contact">
            <h3>Información de contacto</h3>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <span>{sede.direccionCompleta}</span>
            </div>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <span>{sede.telefonoTexto}</span>
            </div>
          </div>

          <div className="sede-buttons" style={{ marginTop: '20px' }}>
            <a href={sede.whatsapp} className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> Contactar por WhatsApp
            </a>
          </div>
        </div>

        <div className="sede-image">
          <img src={glew_frente_nuevo} alt="Frente de la sede Glew de Mi Lugar, en Av. Hipólito Yrigoyen 22548, Guernica" />
        </div>
      </section>

      <section className="sede-facilities">
        <h2 className="section-title">Nuestras instalaciones</h2>
        <div className="facilities-grid">
          <div className="facility-item">
            <FaAccessibleIcon className="facility-icon" />
            <div>
              <h3>Accesibilidad total</h3>
              <p>Instalaciones adaptadas para movilidad reducida</p>
            </div>
          </div>
          <div className="facility-item">
            <FaUtensils className="facility-icon" />
            <div>
              <h3>Comedor</h3>
              <p>Servicio de alimentación supervisado</p>
            </div>
          </div>
          <div className="facility-item">
            <FaUserFriends className="facility-icon" />
            <div>
              <h3>Salas terapéuticas</h3>
              <p>Espacios especializados para cada terapia</p>
            </div>
          </div>
          <div className="facility-item">
            <FaMusic className="facility-icon" />
            <div>
              <h3>Sala de música</h3>
              <p>Equipada para musicoterapia</p>
            </div>
          </div>
          <div className="facility-item">
            <FaTree className="facility-icon" />
            <div>
              <h3>Amplios espacios verdes</h3>
              <p>Áreas naturales para actividades recreativas</p>
            </div>
          </div>
          <div className="facility-item">
            <FaSwimmer className="facility-icon" />
            <div>
              <h3>Actividades al aire libre</h3>
              <p>Programas de estimulación en contacto con la naturaleza</p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2 className="section-title">Galería de fotos</h2>
        <Gallery images={galleryImages} />
      </section>

      <section className="map-container">
        <h2 className="section-title">¿Cómo llegar?</h2>
        <p>Estamos ubicados en Av. Hipólito Yrigoyen 22548, B1856 Guernica, Provincia de Buenos Aires.</p>
        <div style={{ marginTop: '20px' }}>
          <a 
            href="https://www.google.com/maps/search/?api=1&query=Av.+Hip%C3%B3lito+Yrigoyen+22548,+Guernica,+Buenos+Aires"
            className="btn"
            target="_blank" 
            rel="noopener noreferrer"
          >
            <FaMapMarkerAlt /> Ver en Google Maps
          </a>
        </div>
        <div style={{ marginTop: '30px', height: '400px' }}>
          <iframe 
            src="https://maps.google.com/maps?q=Av.+Hip%C3%B3lito+Yrigoyen+22548,+Guernica,+Buenos+Aires&hl=es&z=16&output=embed"
            width="100%" 
            height="100%" 
            style={{ border: 0, borderRadius: '8px' }} 
            allowFullScreen="" 
            loading="lazy"
            title="Mapa Sede Glew"
          ></iframe>
        </div>
        <p>Atendemos a niños y jóvenes con discapacidad de Glew, Guernica, Longchamps, Don Orione, Alma Fuerte, Florencio Varela, Ministro Rivadavia, Los Altos y El Roble.</p>
      </section>

       {/* WhatsApp Float Button With Report*/}
      <a
        href={sede.whatsapp}
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Escribinos por WhatsApp"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion(sede.whatsapp);
        }}
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default Glew;
